// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wifi';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.563 17.438 17.438.563M6.75 15.188a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0zm6.225-3.978a5.609 5.609 0 0 0-1.69-1.16M8.438 6.205a8.963 8.963 0 0 0-5.802 2.619m12.728 0a9.012 9.012 0 0 0-1.898-1.452m-2.252-4.36A12.363 12.363 0 0 0 .562 6.136m16.876 0a12.35 12.35 0 0 0-1.829-1.41'
  />
);

export const viewBox = '0 0 18 18';
